/**
 * LogoUploadSection Component
 * 
 * Logo upload section with viewer and photo editor integration
 */

import React, { useRef, ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import PhotoEditor from '../PhotoEditor/PhotoEditor';
import LogoViewer from '../LogoViewer/LogoViewer';
import './LogoUploadSection.scss';

interface LogoUploadSectionProps {
  currentLogoUrl: string | null;
  logoToEdit: File | null;
  showPhotoEditor: boolean;
  onRemoveLogo: () => void;
  onLogoUpload: (file: File) => void;
  onPhotoEditorClose: () => void;
  onPhotoEditorSave: () => void;
  onFinalImageSet: (editedImage: File) => void;
  onLogoUpdated: (newLogoUrl: string) => void;
}

const LogoUploadSection: React.FC<LogoUploadSectionProps> = ({
  currentLogoUrl,
  logoToEdit,
  showPhotoEditor,
  onRemoveLogo,
  onLogoUpload,
  onPhotoEditorClose,
  onPhotoEditorSave,
  onFinalImageSet,
  onLogoUpdated,
}) => {
  const logoInputRef = useRef<HTMLInputElement>(null);

  const handleLogoChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      onLogoUpload(file);
    }
  };

  return (
    <>
      <div className="settings-card">
        <h4>Logo del local</h4>
        {currentLogoUrl ? (
          <LogoViewer imageUrl={currentLogoUrl} onRemove={onRemoveLogo} />
        ) : (
          <Form.Group controlId="company_logo" className="mediopunto-multi-file-upload">
            <Form.Label>Subir logo</Form.Label>
            <Form.Control
              type="file"
              name="company_logo"
              accept="image/*"
              onChange={handleLogoChange}
              ref={logoInputRef}
            />
            <div className="upload-placeholder">
              Haga clic para seleccionar el logo del restaurante
            </div>
          </Form.Group>
        )}
      </div>

      {logoToEdit && (
        <PhotoEditor
          image={logoToEdit}
          show={showPhotoEditor}
          handleClose={onPhotoEditorClose}
          handleSave={onPhotoEditorSave}
          setFinalImage={onFinalImageSet}
          onLogoUpdated={onLogoUpdated}
        />
      )}
    </>
  );
};

export default LogoUploadSection;
